import { render, staticRenderFns } from "./_FlowBlock.vue?vue&type=template&id=2dffc837&scoped=true&"
import script from "./_FlowBlock.vue?vue&type=script&lang=js&"
export * from "./_FlowBlock.vue?vue&type=script&lang=js&"
import style0 from "./_FlowBlock.vue?vue&type=style&index=0&id=2dffc837&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dffc837",
  null
  
)

export default component.exports